import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useRouteLoaderData } from '@remix-run/react';

import type { loader as communityLoader } from '~/routes/community';

import { SignedInAs } from './ui/SignedInAs';

import { useCommunityDisplayName } from '../_hooks/useCommunityDisplayName';
import { getJoinRefusalMessage } from '../_utils/getJoinRefusalMessage';
import { CommunityAuthModal } from './CommunityAuthModal';
import { OwnerGateButton } from './OwnerGateButton';

interface JoinRefusedModalProps {
  onClose: () => void;
  publicationName: string;
}

export const JoinRefusedModal: FC<JoinRefusedModalProps> = ({ onClose, publicationName }) => {
  const { t } = useTranslation();
  const community = useRouteLoaderData<typeof communityLoader>('routes/community')?.community;
  const communityName = useCommunityDisplayName();

  return (
    <CommunityAuthModal
      isOpen
      onClose={onClose}
      title={communityName}
      description={getJoinRefusalMessage(community, t)}
      closeLabel={t('shared.close')}
      publicationName={publicationName}
      footer={<SignedInAs className="text-center text-black/50" />}
    >
      <OwnerGateButton gate={community?.gate} size="lg" fullWidth />
    </CommunityAuthModal>
  );
};
